import React from 'react';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaPlus } from 'react-icons/fa';

import Const from '../../../../util/Constants';
import FieldController from '../../../../controller/FieldController';

class FieldOptionControl extends React.Component {

  constructor(props) {
    super(props);
    this.fieldList = [];
    for(let i = 0; i < props.fields.length; i++) {
      if(props.fields[i].field_type.includes(Const.Select)) {
        this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
          type: props.fields[i].field_type, label: props.fields[i].label_name });
      }
    }
    const fields = props.value ? props.value : [];
    this.state = { ...this.state, fields };
    if(this.props.onOptionsChanged) {
      this.props.onOptionsChanged(fields);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.fieldList = [];
    for(let i = 0; i < props.fields.length; i++) {
      this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
        type: props.fields[i].field_type, label: props.fields[i].label_name });
    }
    const fields = props.value ? props.value : [];
    this.props.onOptionsChanged(fields);
    this.setState({ ...this.state, fields });
  }

  onAdd = field => {
    const fields = [...this.state.fields, { field: field.value, visible: false,
      editable: false, form_mandate: false } ];
    this.props.onOptionsChanged(fields);
    this.setState({ ...this.state, fields, show: false });
  }
  onDelete = index => {
    const fields = [ ...this.state.fields ].filter((_, i) => i !== index);
    this.props.onOptionsChanged(fields);
    this.setState({ ...this.state, fields });
  }
  
  onChange = (i, selections) => {
    let options  = '';
    for(let i = 0; i < selections.length; i++) { 
      options = options + selections[i].value + Const.Opt; 
    }
    options = options !== '' ? Const.Opt + options : '';

    const fields = [ ...this.state.fields ];
    fields[i].options = options;
    this.props.onOptionsChanged(fields);
    this.setState({ ...this.state, fields });
  }

  render() {
    return (
      <>
        <Modal aria-labelledby="contained-modal-title-vcenter" size="md" className="w-660" 
          centered show={this.state.show}
          onHide={() => this.setState({ ...this.state, show: false})}
          onExit={() => this.setState({ ...this.state, show: false})}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Add Field</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select className="mr-sm-2"
              onChange={selected => this.onAdd(selected) }
              options={this.fieldList} isSearchable={true} isClearable={true} />
          </Modal.Body>
        </Modal>
        
        <div className="formhead col-md-12">
          <h4>Change Options in Field <Button variant="primary" onClick={() => this.setState({ ...this.state, show: true})}><FaPlus />
          </Button></h4>
        </div>

        { this.state.fields.map((field, i) => {
            const currentFild = this.fieldList.find(ietm => ietm.value === field.field);
            const options = FieldController.getOptions(this.props.model.fields[field.field]);
            const selections = options.filter(item => 
              field.options && field.options.includes(`${Const.Opt}${item.value}${Const.Opt}`));
            return <div key={`access_${i}`} className="col-md-12 condition-select-div">
              {currentFild.label}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Select 
                value={selections} 
                onChange={selections => this.onChange(i, selections)}
                options={options}
                isSearchable={true}
                isClearable={true} 
                isMulti={true} />
            </div>
          })
        }
      </>
    );
  }
}
export default FieldOptionControl;